import React from "react"
import styled, { css } from "styled-components"
import Arrow from "../../images/arrow.inline.svg"
import {
  AppFunctionComponent,
  Quote as QuoteType,
  RenderRichText,
} from "../../types"
import Section, { SectionHeading } from "./sections/section.component"
import { ArrowsWrapper } from "./slider.component"
import {
  FullSizeSliderNavigationButtons,
  Slider,
  Slides,
} from "./slider/slider"
import { ScrollAnchor } from "./sections/custom/innovation-lab-form/innovation-lab.component"
import ArticleListResolver from "../../resolvers/article-item/article-item.resolver"
import { renderRichText } from "gatsby-source-contentful/rich-text"

const SliderWrapper = styled(Slider)`
  display: grid;
  grid-template-areas: "Quote";
  height: 100%;
`

const SlidesWrapper = styled(Slides)`
  grid-area: Quote;
  max-height: 100%;
`

export const ArrowIcon = styled(Arrow)`
  height: 15px;
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    height: 22px;
  }
`

const Arrows = styled(ArrowsWrapper)`
  height: 50px;
  width: 100%;
  position: relative;
  bottom: 0;
  margin-top: 48px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    height: 100%;
    position: absolute;
    top: 0;
    margin-top: 0;
  }
`

const ArticleSectionHeading = styled(SectionHeading)`
  grid-area: unset;
  margin-bottom: 64px;
  h2 {
    text-align: center;
    font-family: Facto;
    font-size: 23px;
    font-style: normal;
    font-weight: 500;
    line-height: 37px;
    margin: 0; /* 160.87% */
  }
`

const ArticleSection = styled.div<{ isKompaktQuoteSlider: boolean }>`
  ${({ isKompaktQuoteSlider }) =>
    isKompaktQuoteSlider &&
    css`
      background: #f4f5f7;
      padding-bottom: 112px;
      padding-top: 60px;

      @media (max-width: ${({ theme }) =>
          theme.breakpoint.tabletHorizontal}px) {
        padding-bottom: 48px;
        padding-top: 40px;
      }
    `}
`

interface Props {
  slides: QuoteType[]
  title?: string
  anchorId?: string
  text?: RenderRichText
}

const ArticleListSlider: AppFunctionComponent<Props> = ({
  className = "",
  slides,
  text,
  title = "Quote slider",
  anchorId,
}) => {
  const isKompaktQuoteSlider = title === "Quotes slider Kompakt"
  return (
    <ArticleSection isKompaktQuoteSlider={isKompaktQuoteSlider}>
      <Section className={className}>
        <ScrollAnchor id={anchorId} />
        {text && (
          <ArticleSectionHeading>{renderRichText(text)}</ArticleSectionHeading>
        )}
        <SliderWrapper title={title}>
          <SlidesWrapper>
            {slides.map((slide, index) => (
              <ArticleListResolver {...slide} key={index} />
            ))}
          </SlidesWrapper>
          <Arrows>
            <FullSizeSliderNavigationButtons />
          </Arrows>
        </SliderWrapper>
      </Section>
    </ArticleSection>
  )
}

export default ArticleListSlider
